import { render, staticRenderFns } from "./BlackListModal.vue?vue&type=template&id=54e5f454&scoped=true&"
import script from "./BlackListModal.vue?vue&type=script&lang=js&"
export * from "./BlackListModal.vue?vue&type=script&lang=js&"
import style0 from "./BlackListModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BlackListModal.vue?vue&type=style&index=1&id=54e5f454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e5f454",
  null
  
)

export default component.exports